'use client';

import { SUPPORTED_CHAINS } from '@frontend/common';
import { defaultPublicRpc } from '@frontend/utils/env.client';
import { createConfig } from '@privy-io/wagmi';
import { cookieStorage, createStorage } from '@wagmi/core';
import { http } from 'viem';
import { coinbaseWallet, injected, walletConnect } from 'wagmi/connectors';

const projectId = process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID;

if (!projectId) {
  throw new Error('NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID is not set');
}

const transports = Object.fromEntries(
  SUPPORTED_CHAINS.map((chain) => [
    chain.id,
    http(defaultPublicRpc(chain.id), { batch: true }),
  ]),
) as Record<(typeof SUPPORTED_CHAINS)[number]['id'], ReturnType<typeof http>>;

export const wagmiConfig = createConfig({
  chains: SUPPORTED_CHAINS,
  connectors: [
    injected(),
    coinbaseWallet({
      appName: 'yodl',
      preference: 'all',
    }),
    walletConnect({
      projectId,
      metadata: {
        name: 'yodl',
        description: 'yodl',
        url: 'https://yodl.me',
        icons: ['https://yodl.me/assets/images/favicon-96x96.png'],
      },
    }),
  ],
  transports,
  ssr: true,
  storage: createStorage({
    storage: cookieStorage,
  }),
});
